import axios, { AxiosRequestConfig } from "axios";
import { getEnv } from "../../AppConfigs";
import { store } from "../../store/store";
import { ObjectUtils } from "../../modules/utils";
import { UAParser } from "ua-parser-js";
import { SET_FORBIDDEN_ERROR, SET_UNAUTHORIZED_ERROR } from "../main/main.reducer";

const BASE_URL = getEnv("REACT_APP_DOCUMENT_SERVICE_URL");

const sDocumentAxios = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json" },
});

const authHeader = (config: AxiosRequestConfig) => {
  const parser = new UAParser();
  const result = parser.getResult();
  const userToken = store.getState().user?.current?.accessToken;

  return ObjectUtils.cleanObj({
    Authorization: userToken ? `Bearer ${userToken}` : undefined,
    Prefer: "HonorNonIndexedQueriesWarningMayFailRandomly",
    X_APP_NAME: result.browser.name || "",
    X_APP_LANGUAGE: navigator.language || "en-US",
  });
};

// Request Interceptor
sDocumentAxios.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    config.headers = {
      ...(config.headers || {}),
      ...authHeader(config),
    };
    console.log("✅ Interceptor hit:", config.url, config);
    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor
sDocumentAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    if (status === 401) {
      store.dispatch({ type: SET_UNAUTHORIZED_ERROR, status: true });
    } else if (status === 403) {
      store.dispatch({ type: SET_FORBIDDEN_ERROR, status: true });
    }
    return Promise.reject(error);
  }
);

export default sDocumentAxios;
